<template>
  <el-card shadow="always" :body-style="{ padding: '20px', height: '72vh' }">
    <div slot="header">
      <div class="flex" style="justify-content: space-between;">
        <div>
          <img src="@/assets/home/new.png" alt="" />
          <span class="hardtext">装配式构件生产</span>
        </div>
        <el-button type="primary" @click="JobperiodVisible = true"
          >添加工期</el-button
        >
      </div>
    </div>
    <!-- card body -->
    <div>
      <el-table
        stripe
        :header-cell-style="{
          background: '#EBEFF2',
          color: '#1E2134',
          fontWeight: 'bold',
        }"
        :data="WorktableData"
      >
        <el-table-column align="center" label="序号" type="index" width="80">
        </el-table-column>
        <el-table-column align="center" prop="cppd03" label="工期阶段名称">
        </el-table-column>
        <el-table-column align="center" prop="cppd04" label="开始时间">
        </el-table-column>
        <el-table-column align="center" prop="cppd05" label="结束时间">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="EditDown(scope.row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="确定删除这条数据吗？"
              @confirm="delDown(scope.row)"
            >
              <el-button
                type="danger"
                style="margin-left: 10px;"
                slot="reference"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right"
        background
        @size-change="DownhandleSizeChange"
        @current-change="DownhandleCurrentChange"
        :current-page.sync="DonwpageIndex"
        :page-size="DonwpageSize"
        layout="prev, pager, next, jumper"
        :total="Donwtotal"
      >
      </el-pagination>
    </div>
    <!-- 添加工期倒计时 -->
    <el-dialog title="添加" :visible.sync="JobperiodVisible" width="30%">
      <el-form ref="JobForm" :model="JobForm" label-width="80px">
        <el-form-item label="工期名称">
          <el-input
            style="width: 400px"
            v-model="JobForm.JobName"
            placeholder="请输入工期名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            style="width: 400px"
            v-model="JobForm.Jobstart"
            type="datetime"
            placeholder="选择日期开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            style="width: 400px"
            v-model="JobForm.Jobend"
            type="datetime"
            placeholder="选择日期结束时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="JobperiodVisible = false">取 消</el-button>
        <el-button type="primary" @click="determineDonw('JobForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑工期倒计时 -->
    <el-dialog title="编辑" :visible.sync="JobEditdVisible" width="30%">
      <el-form ref="EditJobForm" :model="EditJobForm" label-width="80px">
        <el-form-item label="工期名称">
          <el-input
            style="width: 400px"
            v-model="EditJobForm.EJobName"
            placeholder="请输入工期名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            style="width: 400px"
            v-model="EditJobForm.EJobstart"
            type="datetime"
            placeholder="选择日期开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            style="width: 400px"
            v-model="EditJobForm.EJobend"
            type="datetime"
            placeholder="选择日期结束时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="JobEditdVisible = false">取 消</el-button>
        <el-button type="primary" @click="EditdeterDonw('EditJobForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  Getcmplist,
  insertcomponentproduce,
  updatecmp,
  deletecmp,
} from "@/setAxios";
import dayjs from "dayjs";
export default {
  name: "RunhongXUGK",
  data() {
    return {
      dialogVisible: false,
      WorktableData: [], //工期倒计时列表
      DonwpageIndex: 1, //倒计时日期当前页
      DonwpageSize: 10, //倒计时日期条数
      Donwtotal: 0, //倒计时日期总条数
      JobperiodVisible: false, //添加工期弹窗
      JobEditdVisible: false, //编辑工期弹窗
      JobForm: {
        JobName: "",
        Jobstart: "",
        Jobend: "",
      },
      EditJobForm: {
        Eid: "",
        EJobName: "",
        EJobstart: "",
        EJobend: "",
      },
    };
  },

  mounted() {},
  created() {
    this.getProDonwList();
  },
  methods: {
    //获取工期倒计时数据
    getProDonwList() {
      let params = {
        xid: this.$store.state.xid,
        pageindex: this.DonwpageIndex,
        pageSize: this.DonwpageSize,
      };
      Getcmplist({ params }).then((res) => {
        res.Data.list.forEach((element) => {
          element.cppd04 = dayjs(element.cppd04).format("YYYY年MM月DD日");
          element.cppd05 = dayjs(element.cppd05).format("YYYY年MM月DD日");
        });
        this.WorktableData = res.Data.list;
        this.Donwtotal = res.Data.total;
      });
    },
    //添加工期倒计时确定按钮
    async determineDonw(JobForm) {
      if (
        this.JobForm.JobName == "" ||
        this.JobForm.Jobstart == "" ||
        this.JobForm.Jobstart == null ||
        this.JobForm.Jobend == "" ||
        this.JobForm.Jobend == null
      ) {
        this.$message({
          message: "请填写完整后提交！",
          type: "warning",
        });
        return;
      }
      if (this.JobForm.Jobstart >= this.JobForm.Jobend) {
        this.$message({
          message: "结束时间不能小于开始时间！",
          type: "warning",
        });
        return;
      }
      let params = {
        cppd02: this.$store.state.xid,
        cppd03: this.JobForm.JobName,
        cppd04: this.JobForm.Jobstart,
        cppd05: this.JobForm.Jobend,
      };
      let res = await insertcomponentproduce(params);
      if (res.Code) {
        this.$message({
          type: "success",
          message: "添加成功!",
        });
        this.JobperiodVisible = false;
        this.getProDonwList();
        this.JobForm = {
          JobName: "",
          Jobstart: "",
          Jobend: "",
        };
      } else {
        this.$message({
          type: "error",
          message: "添加失败!",
        });
        return;
      }
    },
    //删除工期倒计时
    async delDown(row) {
      let params = {
        id: row.cppd01,
      };
      let res = await deletecmp(params);
      if (res.Code) {
        this.$message({
          type: "success",
          message: "移除成功!",
        });
        this.getProDonwList();
      } else {
        this.$message({
          type: "error",
          message: "移除失败!",
        });
        return;
      }
    },
    //打开编辑工期倒计时弹窗
    EditDown(row) {
      this.JobEditdVisible = true;
      this.EditJobForm.Eid = row.cppd01;
      this.EditJobForm.EJobName = row.cppd03;
      this.EditJobForm.EJobstart = row.cppd04
        .replace("年", "/")
        .replace("月", "/")
        .replace("日", "");
      this.EditJobForm.EJobend = row.cppd05
        .replace("年", "/")
        .replace("月", "/")
        .replace("日", "");
    },
    //编辑工期确定按钮
    async EditdeterDonw(EditJobForm) {
      if (
        this.EditJobForm.EJobName == "" ||
        this.EditJobForm.EJobstart == null ||
        this.EditJobForm.EJobend == null
      ) {
        this.$message({
          message: "请填写完整后提交！",
          type: "warning",
        });
        return;
      }
      let params = {
        cppd01: this.EditJobForm.Eid,
        cppd03: this.EditJobForm.EJobName,
        cppd04: this.EditJobForm.EJobstart,
        cppd05: this.EditJobForm.EJobend,
      };
      let res = await updatecmp(params);
      if (res.Code) {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
        this.JobEditdVisible = false;
        this.getProDonwList();
      } else {
        this.$message({
          type: "error",
          message: "修改失败!",
        });
        return;
      }
    },
    //工期倒计时条数
    DownhandleSizeChange(val) {
      this.DonwpageSize = val;
      this.getProDonwList();
    },
    //工期倒计时当前页
    DownhandleCurrentChange(val) {
      this.DonwpageIndex = val;
      this.getProDonwList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
